import { createContext, useContext, useEffect, useState } from "react";
import { StaticGoalCalculate } from "../functions/getStreak";

const ProjectsContext = createContext(null);

function normalize(project){
  return {
    ...project,
    settings: {
      chaptersEnabled: project.settings?.chaptersEnabled ?? false,
      MinimumWordsInChapter: project.settings?.MinimumWordsInChapter ?? 1000,
      goalEnabled: project.settings?.goalEnabled ?? false,
      goalMode: project.settings?.goalMode ?? "Auto",
      dailyGoal: project.settings?.dailyGoal ?? 0,
      lastGoalUpdate: project.settings?.lastGoalUpdate ?? ""
    },
    chapters: project.chapters?.map(r =>({
      ...r,
      type: r.type ?? "chapter",
      chapterID: r.ChapterID ?? crypto.randomUUID()
    })) ?? []
  };
}

export function ProjectsProvider({ children }) {
    const [projects, setProjects] = useState(() => {
        const storedProjects = localStorage.getItem("projects");
        const parsed = storedProjects ? JSON.parse(storedProjects) : [];

        const normalizedProjects = parsed.map(normalize);

        const today = new Date().toISOString().split("T")[0];

        return normalizedProjects.map(project => {
          if (
            project.settings.goalEnabled &&
            project.settings.goalMode === "Auto" &&
            project.settings.lastGoalUpdate !== today
          ) {
            return {
              ...project,
              settings: {
                ...project.settings,
                dailyGoal: StaticGoalCalculate(project),
                lastGoalUpdate: today
              }
            };
          }

          return project;
        });
    });

    useEffect(() => {
      localStorage.setItem("projects", JSON.stringify(projects));
    }, [projects]);

    const deleteProject = (index) => {
      setProjects(prev => prev.filter((_, i) => i !== index));
    };

    return (
      <ProjectsContext.Provider value={{ projects, setProjects, deleteProject }}>
        {children}
      </ProjectsContext.Provider>
    );
}

export function useProjectsContext() {
  const ctx = useContext(ProjectsContext);
  if (!ctx) {
    throw new Error("useProjectsContext must be used inside ProjectsProvider");
  }
  return ctx;
}